import protoRoot from "./proto-root";
import debug from "src/modules/debug-logger";
import { v4 as uuid4 } from "uuid";
// const { Buffer } = window.require("buffer");

export const MAX_BYTE_LENGTH = 60 * 1000;

/* 
message MultiPart {
    string uuid = 1;
    int32 total = 2;
    int32 part = 3;
    bytes data = 4;
}
 */

export function createMultiPart(payload) {
  const MultiPart = protoRoot.lookupType("comm.MultiPart");
  const multiPart = MultiPart.create(payload);
  return multiPart;
}

export function createMultiParts(buffer) {
  const uuid = uuid4();
  const byteLength = Buffer.byteLength(buffer);
  const numberOfParts = Math.ceil(byteLength / MAX_BYTE_LENGTH);

  debug.protoBuffers("NumberOfParts:", numberOfParts);

  const multiParts = [];
  for (let i = 0; i < numberOfParts; i++) {
    const start = i * MAX_BYTE_LENGTH;
    debug.protoBuffers("Current buffer start:", start);

    const end = start + MAX_BYTE_LENGTH;
    debug.protoBuffers("Current buffer end:", end);

    const part = buffer.slice(start, end);

    const multiPart = createMultiPart({
      uuid,
      total: numberOfParts,
      part: i,
      data: part
    });
    debug.protoBuffers("Created multiPart", multiPart);
    multiParts.push(multiPart);
  }
  debug.protoBuffers("Returning multiParts", multiParts);
  return multiParts;
}
